import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { loadFeatureBasedTranslations } from './src/i18n/utils/transformResources'
import { uiResources } from '@popety-io/ui'

// Import feature-based translation files
import common from './i18n/features/common.json'
import explore from './i18n/features/explore.json'
import estimate from './i18n/features/estimate.json'
import history from './i18n/features/history.json'
import transactions from './i18n/features/transactions.json'
import noise from './i18n/features/noise.json'
import sunlight from './i18n/features/sunlight.json'
import zoning from './i18n/features/zoning.json'
import quickFilter from './i18n/features/quickFilter.json'
import reports from './i18n/features/reports.json'
import pipeline from './i18n/features/pipeline.json'
import analysisShare from './i18n/features/analysisShare.json'
import amenities from './i18n/features/amenities.json'
import alerts from './i18n/features/alerts.json'
import settings from './i18n/features/settings.json'
import auth from './i18n/features/auth.json'
import feasibilityStudy from './i18n/features/feasibilityStudy.json'
import demographics from './i18n/features/demographics.json'
import employment from './i18n/features/employment.json'
import transport from './i18n/features/transport.json'
import charts from './i18n/features/charts.json'
import buildings from './i18n/features/buildings.json'
import buildingPermits from './i18n/features/buildingPermits.json'
import listings from './i18n/features/listings.json'
import market from './i18n/features/market.json'
import energy from './i18n/features/energy.json'
import modules from './i18n/features/modules.json'
import landAnalysis from './i18n/features/landAnalysis.json'
import restrictions from './i18n/features/restrictions.json'
import elevation from './i18n/features/elevation.json'
import buildingAnalysis from './i18n/features/building-analysis.json'
import geoAnalysis from './i18n/features/geoAnalysis.json'
import propertyAttributes from './i18n/features/propertyAttributes.json'

// Transform feature-based structure to i18next format
const appResources = loadFeatureBasedTranslations({
  common,
  explore,
  estimate,
  history,
  transactions,
  noise,
  sunlight,
  zoning,
  quickFilter,
  reports,
  pipeline,
  analysisShare,
  amenities,
  alerts,
  settings,
  auth,
  feasibilityStudy,
  demographics,
  employment,
  transport,
  charts,
  buildings,
  buildingPermits,
  listings,
  market,
  energy,
  modules,
  landAnalysis,
  restrictions,
  elevation,
  buildingAnalysis,
  geoAnalysis,
  propertyAttributes,
})

// Merge app resources with UI library resources
const resources = {
  en: { ...appResources.en, ...uiResources.en },
  fr: { ...appResources.fr, ...uiResources.fr },
  de: { ...appResources.de, ...uiResources.de },
  it: { ...appResources.it, ...uiResources.it },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources as any,
    lng: 'en',
    fallbackLng: 'en',
    ns: [
      'common',
      'explore',
      'estimate',
      'history',
      'transactions',
      'noise',
      'sunlight',
      'zoning',
      'quickFilter',
      'reports',
      'pipeline',
      'analysisShare',
      'amenities',
      'alerts',
      'settings',
      'auth',
      'feasibilityStudy',
      'demographics',
      'employment',
      'transport',
      'charts',
      'buildings',
      'buildingPermits',
      'listings',
      'market',
      'energy',
      'modules',
      'landAnalysis',
      'restrictions',
      'elevation',
      'buildingAnalysis',
      'geoAnalysis',
      'propertyAttributes',
      'ui', // UI library translations
      'gwr', // GWR enum translations (building category, class, status)
    ], // Define available namespaces
    defaultNS: 'common', // Set default namespace
    nsSeparator: '.', // Use dot as namespace separator
    keySeparator: '.', // Use dot as key separator
    debug: false, //process.env.NODE_ENV === 'development', // enable debug mode in development
    interpolation: { escapeValue: false }, // this helps to avoid unnecessary HTML escaping
    saveMissing: true, // Enable missing key detection
    missingKeyHandler: (_lngs, _ns, _key) => {
      if (process.env.NODE_ENV !== 'development') return
      // This will trigger the 'missingKey' event

      // console.warn(
      //   `Missing translation: ${ns}:${key} for languages: ${lngs.join(', ')}`
      // )
    },
    parseMissingKeyHandler: (key) => {
      // Get the last part of the key after the last dot
      const parts = key.split('.')
      const lastWord = parts[parts.length - 1]

      // Convert camelCase or snake_case to Title Case
      return lastWord
    },
  })

export default i18n
